import "./UnauthedHome.css";

import postcastLogo from 'Assets/postcast-logo.png';

const Home = (props) => {
  const { onLogin } = props;
  return (
    <div className="unauthed-home-container">
      <img style={{width: 100, height: 100}}src={postcastLogo}/>
      <div className="unauthed-home-container-title"><b>Postcast</b></div>
      <div className="unauthed-home-container-subtitle">
        Automatically create Puzzles, Games, and Quizzes from your content.<br/>
        <b>Boost Subscriber Engagement & Retention</b>
      </div>
    </div>
  );
};

export default Home;
